// src/components/wallet/CoinbaseWalletConnector.js
import React from 'react';
import { useWeb3React } from '@web3-react/core';
import { coinbaseWallet } from '../../web3/connectors';

export default function CoinbaseWalletConnector() {
  const { connector, isActive } = useWeb3React();
  const isCB = connector === coinbaseWallet;

  const connect = async () => {
    try {
      await coinbaseWallet.activate(84532);
    } catch (e) {
      try {
        await coinbaseWallet.activate();
      } catch (err) {
        if (err.code !== 4001) {
          console.error('Coinbase Wallet connection failed', err);
        }
      }
    }
  };

  if (isCB && isActive) return null;

  return (
    <button className="connect-banner-action connect-banner-action--cb" onClick={connect}>
      Connect Coinbase Wallet
    </button>
  );
}
